import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as root } from '$/shows'
import { formatCategoryWithShowsToUi } from '$/shows/lib'
import { nay, T } from '@/helpers'
import { type UiCategoryWithShows } from '@/interfaces'
import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { not } from 'patronum'
import '~/entities/shows/model'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { genPagesLogic } from '~/shared/effector'

// *
// * EVENTS
// *
export const left = createEvent()

export const initShowSubCategory = createEvent<{
  categoryId: number
  subCategoryId: number
  query: URLSearchParams
}>()

export const $shows: Store<UiCategoryWithShows | null> = combine(
  api.tvshows.$showsByCategory,
  ssePurchasesModel.$tvShow,
  i18n.$t,
  (category, adjust, { t }) => formatCategoryWithShowsToUi(category, adjust, t)
)

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * CONNECTIONS
// *
sample({
  clock: initShowSubCategory,
  filter: not(api.tvshows.initShowsCategoryFx.pending),
  fn: (clockData) => ({
    categoryId: Number(clockData.subCategoryId || clockData.categoryId),
  }),
  target: api.tvshows.initShowsCategoryFx,
})

export const loadMoreShowsByCategory = genPagesLogic(
  api.tvshows.$showsByCategoryPageInfo,
  api.tvshows.loadShowsFx
)

/********** Skeleton logics starts ***********/

sample({
  clock: initShowSubCategory,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.tvshows.initShowsCategoryFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.tvshows.$showsByCategory.reset(initShowSubCategory)

register(loadMoreShowsByCategory, 'loadMoreShowsByCategory')
register($shows, '$shows/categories/categoryId/shows')
register(root.$infiniteShowsTitle, '$shows/subcategory/infiniteShowsTitle')
